module.exports = Em.Object.create({
    headers: {}
});
